;(() => {
  const tiktokEmbeds = document.querySelectorAll(".tiktok-embed")
  tiktokEmbeds.forEach((embed) => {
    const tiktokLoadingScreen = embed.nextElementSibling
    const interval = setInterval(() => {
      const tiktokSection = embed.querySelector("section")

      if (!tiktokSection) {
        embed.classList.remove("hidden")
        tiktokLoadingScreen.classList.add("tiktok--loaded")
        clearInterval(interval)
      }
    }, 250)
  })
})()
